import { createFileRoute, Outlet } from '@tanstack/react-router';
import { FlowsNav } from 'src/features/flows/components/FlowsNav';

export const Route = createFileRoute('/_authenticated/flows/_list')({
  component: FlowsListLayout,
});

function FlowsListLayout() {
  return (
    <FlowsNav>
      <Outlet />
    </FlowsNav>
  );
}
